import { render } from "./GhostTabletFormComponentDetails.vue?vue&type=template&id=0e86b068"
import script from "./GhostTabletFormComponentDetails.vue?vue&type=script&lang=js"
export * from "./GhostTabletFormComponentDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__